import React, { Suspense, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Panel } from 'react-bootstrap';
import { navigate } from 'raviger';
import _ from 'lodash';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';
import Permission from '../../components/Permission/Permission';

import { useAlertStore } from '../../store/providers/Alert';
import { useMailMergeTemplateStore } from '../../store/providers/MailMergeTemplate';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';

import Spinner from '../../components/Spinner/Spinner';

import * as constants from '../../constants';

const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const MailMergeTemplateForm = React.lazy(() => import('./MailMergeTemplateForm'));

function MailMergeTemplate(props) {
    const dispatch = useDispatch();

    const { addAlert } = useAlertStore();
    const { selectRecord, newRecord, data, clearData } = useMailMergeTemplateStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isNew, setIsNew] = useState(false);
    //const [isBusy, setIsBusy] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [title, setTitle] = useState('');

    const pagePermission = constants.PERMISSION_CONTENT_MAILMERGETEMPLATES;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const cancelledHandler = (e) => {
        navigate('/mailMerge');
    };

    const submittedHandler = (e) => {
        navigate('/mailMerge');
    };

    useEffect(() => {
        if (!_.isEmpty(data)) {
            if (data.status === 'fail' || data.status === 'error') {
                addAlert({ key: constants.ALERT_SERVER_ERROR, text: <strong>{data.body}</strong>, type: constants.ALERT_TYPE_DANGER });
                clearData();
            }

            if (!isLoaded && isMounted && data.scope === 'select' && data.status === 'success') {
                setTitle(`Edit Mail Merge Template (Id: ${data.body.Id})`);
                setIsLoaded(true);
                dispatch(breadcrumbAddRoute({ key: 'edit-mailMergeTemplate', text: 'Edit Mail Merge Template' }));
            }

            if (!isNew && (data.scope === 'new' && data.status === 'success')) {
                setTitle(`New Mail Merge Template`);
                setIsLoaded(true);
                setIsNew(true);
                dispatch(breadcrumbAddRoute({ key: 'new-mailMergeTemplate', text: 'New Mail Merge Template' }));
            }

            //setIsBusy(data.status === 'processing' && (data.scope === 'update' || data.scope === 'create'));
        }
    }, [props, data, addAlert, clearData, isLoaded, isMounted, isNew, dispatch]);

    useEffect(() => {
        if (hasPermission) { return; }
        if (isMounted) { return; }

        dispatch(breadcrumbAddRoute({ key: 'mailMergeTemplates', parent: 'Content', text: 'Mail Merge Templates', path: '/mailMerge' }));

        if (!_.isEmpty(props.mailMergeTemplateId)) {
            selectRecord({ mailMergeTemplateId: props.mailMergeTemplateId });
        } else {
            newRecord();
        }

        setIsMounted(true);
    }, [isMounted, hasPermission, dispatch, newRecord, props.mailMergeTemplateId, selectRecord]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    return (
        <>
            <SideMenu activeKey="content" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
                {hasPermission && isMounted &&

                    <Suspense fallback={<Spinner text="Loading..." />}>
                        <div style={{ paddingRight: '15px' }}>
                            <PageHeader title={title} />
                            <Panel>
                                <Panel.Body>
                                    <MailMergeTemplateForm
                                        canEdit={canEdit}
                                        mailMergeTemplateId={props.mailMergeTemplateId}
                                        submitted={() => submittedHandler()}
                                        cancelled={() => cancelledHandler()} />
                                </Panel.Body>
                            </Panel>
                        </div>
                    </Suspense>
                }
            </div>
        </>
    );
}

export default withAuthentication(withLayout(MailMergeTemplate));